import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CartElement} from '../../../../../projects/shared-lib/src/lib/models/cart-element';
import {Tax} from '../../../../../projects/shared-lib/src/lib/models/tax';
import { CartHeaderComponent } from '../cart-header/cart-header.component';
import { CartDetailComponent } from '../cart-detail/cart-detail.component';
import { RsComponent } from '../rs/rs.component';
import { CartTaxViewComponent } from '../cart-tax-view/cart-tax-view.component';
import {JsonPipe} from "@angular/common";

interface TimeReserve {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}
@Component({
    selector: 'tw-cart-summary',
    templateUrl: './cart-summary.component.html',
    styleUrls: ['./cart-summary.component.css'],
    imports: [CartHeaderComponent, CartDetailComponent, RsComponent, CartTaxViewComponent, JsonPipe]
})
export class CartSummaryComponent implements OnInit , OnDestroy {

    @Input() cartElements:any| CartElement[];
    @Input() isInCheckout = false;
    @Input() tax:any| Tax;
    @Input() canTaxOverride: boolean = true;

    constructor() {
    }

    ngOnInit() {

    }
    ngOnDestroy(): void {

    }
    get showTax(): boolean {
        if (!this.cartElements) {
            return false;
        }
        if (this.cartElements.length === 1) {
           // return false;
        }
        // return this.cart.tax.t &&
        //     (this.cart.tax.tax1 > 0 || this.cart.tax.tax2 > 0 || this.cart.tax.tax2 > 0);
        return true;
    }

}
